import { render, staticRenderFns } from "./DashboardEquipes.vue?vue&type=template&id=04f89cda"
import script from "./DashboardEquipes.vue?vue&type=script&lang=js"
export * from "./DashboardEquipes.vue?vue&type=script&lang=js"
import style0 from "./DashboardEquipes.vue?vue&type=style&index=0&id=04f89cda&prod&lang=scss"
import style1 from "./DashboardEquipes.vue?vue&type=style&index=1&id=04f89cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports